module.exports = __webpack_public_path__ + "img/play.57a8cc81.svg";